import React from "react"

const Padding = ({ children, ...rest }) => (
  <div className="h-full p-10" {...rest}>
    {children}
  </div>
)

export default Padding
